import { defineAction } from '~/prix'
import { z } from 'zod'
import machineServiceDocumentFetchAction from './machineServiceDocumentFetch.action.json' with { type: 'json' }
import { machineServiceDocumentObject } from '../machineServiceDocumentObject'

const machineServiceDocumentFetchDefinition = defineAction({
  ...machineServiceDocumentFetchAction,

  input: z.object({
    id: machineServiceDocumentObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: machineServiceDocumentObject,
})

export default machineServiceDocumentFetchDefinition
